import React from 'react';
import Page from './Page';
import ShortForm from './ShortForm';

export default class Logout extends Page {

	constructor(...args){
		super(...args);
		this.app.logout();
	}

	componentDidMount(){
		this.app.forceUpdate(); // Trigger a rerender since the user get removed in the constructor.
	}

	render(){
		return (
			<ShortForm
				label="YOU HAVE BEEN LOGGED OUT"
				>
				You have been logged out. Have a nice day!
			</ShortForm>
		);
	}
}





// WEBPACK FOOTER //
// ./src/components/Logout.js